<app-simple [venueFacilities]="venueFacilitiesDTO" ></app-simple>